/**
* Project Name : cop-web-portal
* File Name : CommonToast.vue
* Description : Common Toast Popup
* Author : dhoop.lee
* Date : 2023.8.21
*/
<template>
  <div>
    <span>{{msg}}</span>
    <button
        class="action"
        @click.stop="clicked"
    >SEND!</button>
  </div>
</template>
<script>
export default {
  props: {
    msg: {
      required: false,
      type: String,
    },
  },
  methods: {
    /**
    * param
    * return
    * exception
    * description emit fnc
    * since 2023-08-21
    */
    clicked() {
      this.$emit("fnc");
    },
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/toast/CommonToast.vue